// Header'daki Planlar menüsü için hafif paket verisi.
// packageData.js (tüm özellik detaylarıyla büyük) ana pakete girmesin diye
// yalnızca menünün ihtiyaç duyduğu alanlar burada tutulur.
// Fiyat/ad değişikliklerinde packageData.js ile senkron tutulmalı.
// 17.10.2026 brief: 4 paket — 0 / 90 / 299 / 499 ₺ (USD: $2.90 / $8.90 / $14.90).
export const PACKAGE_ORDER = ["parasyofree", "parasyo-plus", "parasyo-esnaf", "parasyo-pro"];

export const NAV_PACKAGES = {
  parasyofree: {
    name: "ParasyoFree",
    tagline: "Kişisel finansınızı tek yerden takip edin. Kart bilgisi istemeden, ömür boyu ücretsiz.",
    price_tr: "Ücretsiz",
    price_en: "Free",
  },
  "parasyo-plus": {
    name: "Plus",
    tagline: "Bireyler ve aileler için. Home+ ev yönetimi, 550 slot, çek-senet ve öncelikli destek.",
    price_tr: "₺90/ay",
    price_en: "₺90/mo",
    price_foreign_tr: "$2,90/ay",
    price_foreign_en: "$2.90/mo",
  },
  "parasyo-esnaf": {
    name: "Premium",
    tagline: "Dükkânınız için: POS, veresiye, kasa, stok, personel ve e-Fatura dahil.",
    price_tr: "₺299/ay",
    price_en: "₺299/mo",
    price_foreign_tr: "$8,90/ay",
    price_foreign_en: "$8.90/mo",
  },
  "parasyo-pro": {
    name: "Pro",
    tagline: "Şirketler için tam paket. Premium'daki her şey, üstüne CRM, doküman yönetimi, İK+ ve projeler.",
    price_tr: "₺499/ay",
    price_en: "₺499/mo",
    price_foreign_tr: "$14,90/ay",
    price_foreign_en: "$14.90/mo",
  },
};
